BulkListOptionComponent = require 'views/enterprise/dashboard/bulk-actions/option-component'
React = require 'react'
localizeCount = require 'lib/localize-count'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions_team_options_list')
_ = require('underscore')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      members: null
    }

  componentDidMount: ->
    @props.getSelectedMembers.then (members) =>
      onTeamMembers = @_filterOnTeamMembers(members)
      notOnTeamMembers = _.difference(members, onTeamMembers)
      activeMembers = @_filterActiveMembers(onTeamMembers)
      inactiveMembers = @_filterInactiveMembers(onTeamMembers)

      @setState
        members: {
          onTeamMembers
          notOnTeamMembers
          activeMembers
          inactiveMembers
        }

  _filterActiveMembers: (members) ->
    _.filter members, (member) =>
      team = @props.team.toBackbone()
      member = member.toBackbone()

      !team.isVirtual(member) && !team.isDeactivated(member)

  _filterInactiveMembers: (members) ->
    _.filter members, (member) =>
      team = @props.team.toBackbone()
      member = member.toBackbone()

      !team.isVirtual(member) && team.isDeactivated(member)

  _filterOnTeamMembers: (members) ->
    _.filter members, (member) =>
      @props.team.id in _.pluck(member.organizations, 'id')

  render: t.renderable ->
    if !@state.members?
      t.div ->
        t.div '.spinner.loading'
    else
      t.div '.bulk-action-options-list', =>
        t.ul '.pop-over-list', =>
          t.li =>
            t.addElement React.createElement BulkListOptionComponent,
              label: t.l ['add-to-team', 'label'], { teamDisplayName: @props.team.displayName }, { raw: true }
              actionName: t.l ['add-to-team', 'actionName']
              disabledMessage: localizeCount('members already in team', @state.members.onTeamMembers.length)
              members: @state.members.notOnTeamMembers
              onClick: =>
                return if @state.members.notOnTeamMembers.length == 0
                @props.eventHandlers.runBulkActionAdd(@state.members.notOnTeamMembers)

          t.li =>
            t.addElement React.createElement BulkListOptionComponent,
              label: t.l ['deactivate-from-team', 'label'], { teamDisplayName: @props.team.displayName }, { raw: true }
              actionName: t.l ['deactivate-from-team', 'actionName']
              disabledMessage: t.l ['deactivate-from-team', 'disabledMessage']
              members: @state.members.activeMembers
              onClick: =>
                return if @state.members.activeMembers.length == 0
                @props.eventHandlers.runBulkActionDeactivate(@state.members.activeMembers)

          t.li =>
            t.addElement React.createElement BulkListOptionComponent,
              label: t.l ['reactivate-in-team', 'label'], { teamDisplayName: @props.team.displayName }, { raw: true }
              actionName: t.l ['reactivate-in-team', 'actionName']
              disabledMessage: t.l ['reactivate-in-team', 'disabledMessage']
              members: @state.members.inactiveMembers
              onClick: =>
                return if @state.members.inactiveMembers.length == 0
                @props.eventHandlers.runBulkActionReactivate(@state.members.inactiveMembers)

          t.li =>
            t.addElement React.createElement BulkListOptionComponent,
              label: t.l ['remove-from-team', 'label'], { teamDisplayName: @props.team.displayName }, { raw: true }
              actionName: t.l ['remove-from-team', 'actionName']
              disabledMessage: localizeCount('members not in team', @state.members.notOnTeamMembers.length)
              members: @state.members.onTeamMembers
              onClick: =>
                return if @state.members.onTeamMembers.length == 0
                @props.eventHandlers.runBulkActionRemove(@state.members.onTeamMembers, @refs['bulkHardRemove'].checked)

            if @state.members.onTeamMembers.length > 0
              t.span '.check-div.quiet.u-clearfix.bulk-hard-remove', ->
                t.input '.bulk-hard-remove',
                  type: 'checkbox'
                  id: 'bulkHardRemove'
                  defaultChecked: true
                  ref: 'bulkHardRemove'
                t.label { htmlFor: 'bulkHardRemove' }, ->
                  t.format 'remove-from-all-team-boards'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/team-options-list-component.coffee